import React from "react";
import {MenuCampaignMaster} from "../organism/MASTER/Apollo_MasterModel";

export type ColumnData = {
  download: boolean,
  label: string,
}

export type ChartColumnData = {
  index: number,
  viewPattern: number,
  label: string,
}

export type CsvData = {
  index: number,
  data: any[],
}

export type ChartData = (string | number)[][]

export const DefaultMenuMaster: MenuCampaignMaster = {
  menuId: -1,
  menuName: "",
  campaignKindId: 0,
  campaignKindName: "",
  budgetAmountFlg: 0,
  accountCheckFlg: 0,
}

export const options_csv_ms_os_type = [
  {value: 1, label: "iOS/Android"},
  {value: 2, label: "Android"},
  {value: 3, label: "iOS"},
];

// CSVカラム (グラフ)
export const ChartColumns1: ChartColumnData[] = [
  {index: 0, viewPattern: 1, label:"date"},
  {index: 1, viewPattern: 3, label:"cost"},
  {index: 2, viewPattern: 2, label:"imp"},
  {index: 3, viewPattern: 2, label:"vimp"},
  {index: 4, viewPattern: 2, label:"click"},
  {index: 5, viewPattern: 4, label:"CTR"},
  {index: 6, viewPattern: 4, label:"vCTR"},
  {index: 7, viewPattern: 3, label:"平均CPC"},
  {index: 8, viewPattern: 3, label:"CPM"},
  {index: 9, viewPattern: 2, label:"CV(合計)"},
  {index: 10, viewPattern: 5, label:"ラストクリックCV(合計)"},
  {index: 11, viewPattern: 6, label:"アシストクリックCV(合計)"},
  {index: 12, viewPattern: 4, label:"CVR(合計)"},
  {index: 13, viewPattern: 7, label:"ラストクリックCVR(合計)"},
  {index: 14, viewPattern: 4, label:"アシストクリックCVR(合計)"},
  {index: 15, viewPattern: 3, label:"CPA(合計)"},
  {index: 16, viewPattern: 8, label:"ラストクリックCPA(合計)"},
  {index: 17, viewPattern: 3, label:"アシストクリックCPA(合計)"},
  {index: 18, viewPattern: 2, label:"最適化ポイントCV"},
  {index: 19, viewPattern: 4, label:"最適化ポイントCVR"},
  {index: 20, viewPattern: 3, label:"最適化ポイントCPA"},
];

export const ChartColumns2: ChartColumnData[] = [
  {index: 0, viewPattern: 1, label:"date"},
  {index: 1, viewPattern: 3, label:"cost"},
  {index: 2, viewPattern: 2, label:"imp"},
  {index: 4, viewPattern: 2, label:"click"},
  {index: 5, viewPattern: 4, label:"CTR"},
  {index: 7, viewPattern: 3, label:"平均CPC"},
  {index: 8, viewPattern: 3, label:"CPM"},
  {index: 9, viewPattern: 2, label:"CV(合計)"},
  {index: 10, viewPattern: 5, label:"ラストクリックCV(合計)"},
  {index: 11, viewPattern: 6, label:"アシストクリックCV(合計)"},
  {index: 12, viewPattern: 4, label:"CVR(合計)"},
  {index: 13, viewPattern: 7, label:"ラストクリックCVR(合計)"},
  {index: 14, viewPattern: 4, label:"アシストクリックCVR(合計)"},
  {index: 15, viewPattern: 3, label:"CPA(合計)"},
  {index: 16, viewPattern: 8, label:"ラストクリックCPA(合計)"},
  {index: 17, viewPattern: 3, label:"アシストクリックCPA(合計)"},
];

export const ChartColumns3: ChartColumnData[] = [
  {index: 0, viewPattern: 1, label:"date"},
  {index: 1, viewPattern: 3, label:"cost"},
  {index: 2, viewPattern: 2, label:"imp"},
  {index: 4, viewPattern: 2, label:"click"},
  {index: 5, viewPattern: 4, label:"CTR"},
  {index: 7, viewPattern: 3, label:"平均CPC"},
  {index: 8, viewPattern: 3, label:"CPM"},
  {index: 9, viewPattern: 2, label:"CV(合計)"},
  {index: 10, viewPattern: 5, label:"ラストクリックCV(合計)"},
  {index: 11, viewPattern: 6, label:"アシストクリックCV(合計)"},
  {index: 12, viewPattern: 4, label:"CVR(合計)"},
  {index: 13, viewPattern: 7, label:"ラストクリックCVR(合計)"},
  {index: 14, viewPattern: 4, label:"アシストクリックCVR(合計)"},
  {index: 15, viewPattern: 3, label:"CPA(合計)"},
  {index: 16, viewPattern: 8, label:"ラストクリックCPA(合計)"},
  {index: 17, viewPattern: 3, label:"アシストクリックCPA(合計)"},
  {index: 18, viewPattern: 2, label:"最適化ポイントCV"},
  {index: 19, viewPattern: 4, label:"最適化ポイントCVR"},
  {index: 20, viewPattern: 3, label:"最適化ポイントCPA"},
];

export const DemographicChartColumns1: ChartColumnData[] = [
  {index: 0, viewPattern: 1, label:"年齢"},
  {index: 1, viewPattern: 1, label:"性別"},
  {index: 2, viewPattern: 3, label:"cost"},
  {index: 3, viewPattern: 2, label:"imp"},
  {index: 4, viewPattern: 2, label:"vimp"},
  {index: 5, viewPattern: 2, label:"click"},
  {index: 6, viewPattern: 4, label:"CTR"},
  {index: 7, viewPattern: 4, label:"vCTR"},
  {index: 8, viewPattern: 3, label:"平均CPC"},
  {index: 9, viewPattern: 3, label:"CPM"},
  {index: 10, viewPattern: 2, label:"CV(合計)"},
  {index: 11, viewPattern: 5, label:"ラストクリックCV(合計)"},
  {index: 12, viewPattern: 6, label:"アシストクリックCV(合計)"},
  {index: 13, viewPattern: 4, label:"CVR(合計)"},
  {index: 14, viewPattern: 7, label:"ラストクリックCVR(合計)"},
  {index: 15, viewPattern: 4, label:"アシストクリックCVR(合計)"},
  {index: 16, viewPattern: 3, label:"CPA(合計)"},
  {index: 17, viewPattern: 8, label:"ラストクリックCPA(合計)"},
  {index: 18, viewPattern: 3, label:"アシストクリックCPA(合計)"},
];

export const DemographicChartColumns2: ChartColumnData[] = [
  {index: 0, viewPattern: 1, label:"年齢"},
  {index: 1, viewPattern: 1, label:"性別"},
  {index: 2, viewPattern: 3, label:"cost"},
  {index: 3, viewPattern: 2, label:"imp"},
  {index: 5, viewPattern: 2, label:"click"},
  {index: 6, viewPattern: 4, label:"CTR"},
  {index: 8, viewPattern: 3, label:"平均CPC"},
  {index: 9, viewPattern: 3, label:"CPM"},
  {index: 10, viewPattern: 2, label:"CV(合計)"},
  {index: 11, viewPattern: 5, label:"ラストクリックCV(合計)"},
  {index: 12, viewPattern: 6, label:"アシストクリックCV(合計)"},
  {index: 13, viewPattern: 4, label:"CVR(合計)"},
  {index: 14, viewPattern: 7, label:"ラストクリックCVR(合計)"},
  {index: 15, viewPattern: 4, label:"アシストクリックCVR(合計)"},
  {index: 16, viewPattern: 3, label:"CPA(合計)"},
  {index: 17, viewPattern: 8, label:"ラストクリックCPA(合計)"},
  {index: 18, viewPattern: 3, label:"アシストクリックCPA(合計)"},
];

// CSVカラム (datatables)
export const AccountSummaryColumns: ColumnData[] = [
  {download: true, label: "広告主アカウントID"},
  {download: true, label: "広告主アカウント名"},
  {download: true, label: "アカウントグループ_ID"},
  {download: true, label: "アカウントグループ名"},
  {download: true, label: "ステータス"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "vimp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "vCTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "CV(合計)"},
  {download: true, label: "ラストクリックCV(合計)"},
  {download: true, label: "アシストクリックCV(合計)"},
  {download: true, label: "CVR(合計)"},
  {download: true, label: "ラストクリックCVR(合計)"},
  {download: true, label: "アシストクリックCVR(合計)"},
  {download: true, label: "CPA(合計)"},
  {download: true, label: "ラストクリックCPA(合計)"},
  {download: true, label: "アシストクリックCPA(合計)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCVR"},
  {download: true, label: "最適化ポイントCPA"},
];

export const UserColumns: ColumnData[] = [
  {download: true, label: "ユーザーID"},
  {download: true, label: "メールアドレス"},
  {download: true, label: "氏名(姓)"},
  {download: true, label: "氏名(名)"},
  {download: true, label: "所有ロール数"},
  {download: true, label: "システム権限"},
];

export const BudgetColumns: ColumnData[] = [
  {download: true, label: "広告主アカウントID"},
  {download: true, label: "広告主アカウント名"},
  {download: true, label: "アカウントグループID"},
  {download: true, label: "アカウントグループ名"},
  {download: true, label: "アカウント月額予算"},
  {download: true, label: "パフォーマンス広告"},
  {download: true, label: "メッセージS"},
  {download: true, label: "リアルタイムメッセージS"},
];

export const AccountGroupColumns: ColumnData[] = [
  {download: true, label: "アカウントグループID"},
  {download: true, label: "アカウントグループ名"},
  {download: true, label: "ステータス"},
  {download: true, label: "作成日"},
  {download: true, label: "作成者"},
];

export const AccountColumns: ColumnData[] = [
  {download: true, label: "広告主アカウントID"},
  {download: true, label: "広告主アカウント名"},
  {download: true, label: "当月予算"},
  {download: true, label: "広告主名"},
  {download: true, label: "ステータス"},
  {download: true, label: "承認状況"},
  {download: true, label: "パフォーマンス広告"},
  {download: true, label: "メール広告"},
];

export const MasterProductColumns: ColumnData[] = [
  {download: true, label: "商品ID"},
  {download: true, label: "広告主名"},
  {download: true, label: "商品名称"},
  {download: true, label: "業種ID"},
  {download: true, label: "業種カテゴリ"},
  {download: true, label: "業種"},
];

export const MasterIndustryColumns: ColumnData[] = [
  {download: true, label: "業種ID"},
  {download: true, label: "業種カテゴリ"},
  {download: true, label: "業種"},
  {download: true, label: "商品数"},
];

export const MasterBillingResourceColumns: ColumnData[] = [
  {download: true, label: "請求リソースID"},
  {download: true, label: "請求リソース名称"},
  {download: true, label: "与信限度額"},
];

export const CampaignColumns: ColumnData[] = [
  {download: true, label: "キャンペーンID"},
  {download: true, label: "メニュー"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "取引形式"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "ステータス"},
  {download: true, label: "キャンペーンの目的"},
  {download: true, label: "課金種別"},
  {download: true, label: "日予算"},
  {download: true, label: "掲載開始日時"},
  {download: true, label: "掲載終了日時"},
  {download: true, label: "目標CPA"},
  {download: true, label: "配信先ドメイン設定"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "vimp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "vCTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "CV(合計)"},
  {download: true, label: "ラストクリックCV(合計)"},
  {download: true, label: "アシストクリックCV(合計)"},
  {download: true, label: "CVR(合計)"},
  {download: true, label: "ラストクリックCVR(合計)"},
  {download: true, label: "アシストクリックCVR(合計)"},
  {download: true, label: "CPA(合計)"},
  {download: true, label: "ラストクリックCPA(合計)"},
  {download: true, label: "アシストクリックCPA(合計)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCVR"},
  {download: true, label: "最適化ポイントCPA"},
];

export const AdGroupsZeusColumns: ColumnData[] = [
  {download: true, label: "広告グループID"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "取引形式"},
  {download: true, label: "プレースメント"},
  {download: true, label: "ステータス"},
  {download: true, label: "課金種別"},
  {download: true, label: "目標CPC"},
  {download: true, label: "上限CPM"},
  {download: true, label: "配信OS"},
  {download: true, label: "ターゲティング"},
  {download: true, label: "デモグラ情報_性別"},
  {download: true, label: "デモグラ情報_年齢"},
  {download: true, label: "デモグラ情報_居住地"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "CV(合計)"},
  {download: true, label: "ラストクリックCV(合計)"},
  {download: true, label: "アシストクリックCV(合計)"},
  {download: true, label: "CVR(合計)"},
  {download: true, label: "ラストクリックCVR(合計)"},
  {download: true, label: "アシストクリックCVR(合計)"},
  {download: true, label: "CPA(合計)"},
  {download: true, label: "ラストクリックCPA(合計)"},
  {download: true, label: "アシストクリックCPA(合計)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCVR"},
  {download: true, label: "最適化ポイントCPA"},
];

export const AdGroupsMsColumns: ColumnData[] = [
  {download: true, label: "広告グループID"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "ステータス"},
  {download: true, label: "広告種別"},
  {download: true, label: "課金種別"},
  {download: true, label: "入札単価"},
  {download: true, label: "配信OS"},
  {download: true, label: "ターゲティング"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "CV(合計)"},
  {download: true, label: "ラストクリックCV(合計)"},
  {download: true, label: "アシストクリックCV(合計)"},
  {download: true, label: "CVR(合計)"},
  {download: true, label: "ラストクリックCVR(合計)"},
  {download: true, label: "アシストクリックCVR(合計)"},
  {download: true, label: "CPA(合計)"},
  {download: true, label: "ラストクリックCPA(合計)"},
  {download: true, label: "アシストクリックCPA(合計)"},
];

export const AdvertisementZeusColumns: ColumnData[] = [
  {download: true, label: "広告ID"},
  {download: true, label: "広告名"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "取引形式"},
  {download: true, label: "広告種別"},
  {download: true, label: "ステータス"},
  {download: true, label: "審査ステータス"},
  {download: true, label: "アセット1_ID"},
  {download: true, label: "アセット1_URL"},
  {download: true, label: "アセット2_ID"},
  {download: true, label: "アセット2_URL"},
  {download: true, label: "見出し1"},
  {download: true, label: "見出し2"},
  {download: true, label: "見出し3"},
  {download: true, label: "説明文1"},
  {download: true, label: "説明文2"},
  {download: true, label: "説明文3"},
  {download: true, label: "情報提供者名"},
  {download: true, label: "ClickToAction"},
  {download: true, label: "最終リンク先URL"},
  {download: true, label: "情報提供者ドメイン"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "CV(合計)"},
  {download: true, label: "ラストクリックCV(合計)"},
  {download: true, label: "アシストクリックCV(合計)"},
  {download: true, label: "CVR(合計)"},
  {download: true, label: "ラストクリックCVR(合計)"},
  {download: true, label: "アシストクリックCVR(合計)"},
  {download: true, label: "CPA(合計)"},
  {download: true, label: "ラストクリックCPA(合計)"},
  {download: true, label: "アシストクリックCPA(合計)"},
  {download: true, label: "最適化ポイントCV"},
  {download: true, label: "最適化ポイントCVR"},
  {download: true, label: "最適化ポイントCPA"},
];

export const AdvertisementMsColumns: ColumnData[] = [
  {download: true, label: "広告ID"},
  {download: true, label: "広告名"},
  {download: true, label: "広告グループ名"},
  {download: true, label: "キャンペーン名"},
  {download: true, label: "キャンペーン種別"},
  {download: true, label: "ステータス"},
  {download: true, label: "審査ステータス"},
  {download: true, label: "アセットID"},
  {download: true, label: "cost"},
  {download: true, label: "imp"},
  {download: true, label: "click"},
  {download: true, label: "CTR"},
  {download: true, label: "平均CPC"},
  {download: true, label: "CPM"},
  {download: true, label: "CV(合計)"},
  {download: true, label: "ラストクリックCV(合計)"},
  {download: true, label: "アシストクリックCV(合計)"},
  {download: true, label: "CVR(合計)"},
  {download: true, label: "ラストクリックCVR(合計)"},
  {download: true, label: "アシストクリックCVR(合計)"},
  {download: true, label: "CPA(合計)"},
  {download: true, label: "ラストクリックCPA(合計)"},
  {download: true, label: "アシストクリックCPA(合計)"},
];

export const CrAssetMsColumns: ColumnData[] = [
  {download: true, label: "広告アセットID"},
  {download: true, label: "広告アセット名"},
  {download: true, label: "フォーマットタイプ"},
  {download: true, label: "広告設定"},
];

export const SegmentCustomColumns: ColumnData[] = [
  {download: true, label: "ID"},
  {download: true, label: "アカウントグループID"},
  {download: true, label: "ステータス"},
  {download: true, label: "セグメント名"},
  {download: true, label: "UU"},
  {download: true, label: "アカウント連携"},
  {download: true, label: "用途設定"},
  {download: true, label: "タイプ"},
  {download: true, label: "利用設定"},
  {download: true, label: "最終更新ユーザ"},
  {download: true, label: "最終更新"},
];

export const RESULT_ACCOUNT_ERROR = -1
export const RESULT_SETPOINT_ERROR = -1

export const FORMAT_YYYY_MM_DD = "YYYY-MM-DD"
export const FORMAT_YYYY_MM_DD_HHmm = "YYYY-MM-DD HH:mm"
export const FORMAT_YYYY_MM_DD_HHmmss = "YYYY-MM-DD HH:mm:ss"
export const FORMAT_START_DAY_YYYY_MM_DD_HHmmss = "YYYY-MM-DDT00:00:00"
export const FORMAT_END_DAY_YYYY_MM_DD_HHmmss = "YYYY-MM-DDT23:59:00"

export const BLANK = "";
export const DATETIME_SCHEDULED = "日時指定";
export const WEEK = "曜";
export const DAY = "日";
export const ALL = "all";
export const SELECT_ALL = "すべて";
export const VALID_STATUS = "有効";
export const INVALID_STATUS = "停止中";
export const UNDER_SCORE = "_";
export const COMMA = ",";
export const NULL_YEAR = "0001";
export const INIT_YEAR_DATE = "1900-01-01";
export const INVALID_DATE = "Invalid date";
export const UNNAMED_REPORT = "無題のレポート";
export const INIT_EXTRACT_WEEK = "[0,0,0,0,0,0,0]";

export const ZERO = 0;
export const REPORT_DOWNLOAD_EXPIRATION_DATE = 90;
export const REPORT_SCHEDULE_END_DATE_MAX = 365;
export const REPORT_DEFAULT_SCHEDULE_END_DATE = 90;
export const DEMOGRAPHIC_REPORT_MAX_PERIOD = 31;

export enum RESULT_CODE {
  SUCCESS = 0,
  INFO = 1,
  PARAMETER_ERROR = -1,
  BUSY_ERROR = -2,
  ERROR = -9,
}

export enum HTTP_STATUS_CODE {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
}

export const MSG = {
  SUCCESS_GET_REPORT_RERUN: "レポート出力の再実行に成功しました",
  SUCCESS_POST_REPORT_SETTING: "予約レポートの作成に成功しました",
  SUCCESS_PUT_REPORT_SETTING: "予約レポートの更新に成功しました",
  SUCCESS_DELETE_REPORT_SETTING: "予約レポートの削除に成功しました",
  SUCCESS_REPORT_REALTIME: "レポートの作成に成功しました",
  WARNING_REPORT_REALTIME: "レポート作成対象が存在しないため、レポートの作成が出来ません",
  WARNING_REPORT_REALTIME_BUSY: "処理が混み合っています。時間をおいて再度お試しください。",
  ERROR_TRACKER_ID: "トラッカーIDが指定されていません",
  ERROR_GET_ACCOUNT: "アカウント情報取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_ACCOUNT_CAMPAIGN: "広告主アカウントキャンペーンの取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_CAMPAIGN: "キャンペーン情報取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_ADGROUP: "広告グループ情報取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_ADVERTISEMENT: "広告情報取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_DEMOGRAPHIC_PERFORMANCE: "デモグラ実績情報取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_SET_POINTS: "測定ポイント設定のデータ取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_REPORT_SETTING: "予約レポートの取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_REPORT: "出力済みレポートの取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_REPORT_DOWNLOAD: "レポートCSVダウンロードに失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_REPORT_OUTPUT_COLUMNS_MASTER: "レポート出力カラムマスタ情報取得に失敗しました。しばらく経ってから再度お試しください",
  ERROR_POST_REPORT_SETTING: "予約レポートの作成に失敗しました。しばらく経ってから再度お試しください",
  ERROR_GET_REPORT_RERUN: "レポート出力の再実行に失敗しました。しばらく経ってから再度お試しください",
  ERROR_PUT_REPORT_SETTING: "予約レポートの更新に失敗しました。しばらく経ってから再度お試しください",
  ERROR_DELETE_REPORT_SETTING: "予約レポートの削除に失敗しました。しばらく経ってから再度お試しください",
  ERROR_REPORT_REALTIME: "レポートの作成に失敗しました。しばらく経ってから再度お試しください",
  VALIDATE_REQUIRED: "必須入力項目です",
  VALIDATE_ADVERTISEMENT_NOT_ALLOWED: "広告は選択できません",
  VALIDATE_HOUR_NOT_ALLOWED: "時間は選択できません",
  VALIDATE_START_AT: "開始日時を入力して下さい",
  VALIDATE_END_AT: "終了日時を入力して下さい",
  VALIDATE_START_DATE_BEFORE_END_DATE: "終了日時以前の日時を開始日時に入力して下さい",
  VALIDATE_END_DATE_AFTER_START_DATE: "開始日時以降の日時を終了日時に入力して下さい",
  VALIDATE_DURATION_DAYS: `期間は${DEMOGRAPHIC_REPORT_MAX_PERIOD}日間以内で入力して下さい`,
  VALIDATE_DURATION_MONTHS: "期間は13ヶ月以内で入力して下さい",
  VALIDATE_EXTRACT_WEEK: "曜日を入力して下さい",
  VALIDATE_SCHEDULED_AT: "スケジュール日時を入力して下さい",
  VALIDATE_SCHEDULED_AT_RESTRICTION: "スケジュール日時は翌時０分以降を入力して下さい",
  VALIDATE_SCHEDULED_END_AT: "スケジュールの終了日を入力して下さい",
  VALIDATE_SCHEDULED_END_AT_RESTRICTION: "スケジュールの終了日は本日以降を入力して下さい",
  VALIDATE_SCHEDULE_END_DATE_MAX: `スケジュールの終了日は${REPORT_SCHEDULE_END_DATE_MAX}日以内で入力して下さい`,
  VALIDATE_OUTPUT_COLUMN: "カラムを一つ以上設定してください",
}

export const REPORT_OUTPUT_COLUMNS = {
  MASTER: [1,2,3,4,5,68,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,69,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67],
  CAMPAIGN: [1,2,3,4,5,68,6,7,8,44,45,46,47,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67],
  ADGROUP: [1,2,3,4,5,68,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,44,45,46,47,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67],
  ADVERTISEMENT: [1,2,3,4,5,68,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,22,23,24,69,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67],
  DEMOGRAPHIC_CAMPAIGN: [1,2,3,4,5,6,7,8,44,45,46,47,53,54,55,56,57,58,59,60,61,62,63,64],
  DEMOGRAPHIC_ADGROUP: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,44,45,46,47,53,54,55,56,57,58,59,60,61,62,63,64],
  SETPOINT: [61,62,63,64],
}

export const DEMOGRAPHIC_COLUMNS = {
  AGE_RANGE: ["0-4","5-9","10-14","15-19","20-24","25-29","30-34","35-39","40-44","45-49","50-54","55-59","60-64","65-69","70-74","75-79","80-"],
  GENDER: ["男性", "女性", "不明"],
}

export const TRACKING_POINT = {
  CV_CLICK_THROUGH: "trackingPointCvClickThrough",
  CV_ASSIST: "trackingPointCvAssist",
  CVR_CLICK_THROUGH: "trackingPointCvrClickThrough",
  CPA_CLICK_THROUGH: "trackingPointCpaClickThrough",
}

export const SUMMARY_SETPOINT_COLUMNS = ["trackingPointCvClickThrough", "trackingPointCvAssist", "trackingPointCvrClickThrough", "trackingPointCpaClickThrough"];
export const SUMMARY_GRAPH_HEADERS = ['date', 'cost', 'imp', 'vimp', 'click', 'CTR', 'vCTR', '平均CPC', 'CPM', 'CV(合計)', 'ラストクリックCV(合計)', 'アシストクリックCV(合計)', 'CVR(合計)', 'ラストクリックCVR(合計)', 'アシストクリックCVR(合計)', 'CPA(合計)', 'ラストクリックCPA(合計)', 'アシストクリックCPA(合計)', '最適化ポイントCV', '最適化ポイントCVR', '最適化ポイントCPA'];
export const SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS = ['年齢', '性別', 'cost', 'imp', 'vimp', 'click', 'CTR', 'vCTR', '平均CPC', 'CPM', 'CV(合計)', 'ラストクリックCV(合計)', 'アシストクリックCV(合計)', 'CVR(合計)', 'ラストクリックCVR(合計)', 'アシストクリックCVR(合計)', 'CPA(合計)', 'ラストクリックCPA(合計)', 'アシストクリックCPA(合計)'];

export const REPORT_PERIOD_AUTO_CHANGE_MSG = "不正な値が入力されたため、初期値を設定しました。"
export const REPORT_PERIOD_START_DEFAULT_VALUE_SET_MSG = "開始日に不正な値が入力されたため、初期値を設定しました。"
export const REPORT_PERIOD_END_DEFAULT_VALUE_SET_MSG = "終了日に不正な値が入力されたため、初期値を設定しました。"

export enum REPORT_KIND {
  PERFORMANCE = 1,
  DEMOGRAPHIC,
}

export enum OUTPUT_CASE_LEBEL {
  CAMPAIGN = 1,
  ADGROUP,
  ADVERTISEMENT,
}

export enum AGGREGATION_UNIT {
  SUM_TOTAL = 1,
  MONTH,
  DAY,
  HOUR,
}

export enum DEMOGRAPHIC_REPORT_KIND {
  AGE_GENDER = 1,
  PREFECTURE,
}

export enum EXTRACT_PERIOD_KIND {
  CURRENT_MONTH = 1,
  LAST_MONTH,
  LAST_DAY,
  LAST_SEVEN_DAYS,
  CUSTOM,
}

export enum EXTRACT_FREQUENCY_KIND {
  WEEKLY = 1,
  MONTHLY,
}

export enum SCHEDULE_KIND {
  REPEAT = 1,
  SCHEDULED,
  REALTIME,
}

export enum REPEAT_STATUS {
  RUNNING = 1,
  PAUSED,
}

export enum REPORT_STATUS {
  SUCCESS = 0,
  RECORD_NOT_FOUND = 1,
  FAILURE = 9,
}

export enum NUMBER {
  ONE = 1,
  TWO,
  THREE,
  FOUR,
  FIVE,
  SIX,
  SEVEN,
  EIGHT,
  NINE,
  TEN,
}

export enum MENU {
  OPTIMIZATION = 1,
  MAIL,
}

export enum CHECKBOX_STATE {
  CHECKED = 1,
  UNCHECKED = 0,
}

export enum DOWNLOAD_KIND {
  JPEG = 1,
  PNG,
  CSV,
}

export enum DEMOGRAPHIC_DISPLAY_PERIOD {
  LAST_MONTH = 1,
  LAST_WEEK,
}

export enum GENDER_KIND {
  MALE = 1,
  FEMALE,
  UNKNOON,
}

export enum PERFORMANCE_KIND {
  ACCOUNT = 1,
  CAMPAIGN,
  ADGROUP,
  ADVERTISEMENT,
}